import React, { useState } from 'react';
import { Alert, FormFeedback, Spinner, Form, FormGroup, Label, Row, Col, Input, Button } from 'reactstrap';
import { Global } from '~/App';
import API from '~/API';

// This is a new reusable component for the PAC subscription form.
// It encapsulates the logic and UI for both anonymous and authenticated users.
const FormularioSuscripcion = (props) => {
    const {
        isAnonimo,
        montoMaximo,
        recaudadores,
        servicio,
        empresa,
        empresaNombre,
        usuario,
        documento,
        onLoading
    } = props;

    const [cargando, setCargando] = useState(false);
    const [form, setForm] = useState({
        recaudador: recaudadores.length === 1 ? recaudadores[0] : undefined,
        nombre: usuario?.nombre || '',
        apellido: usuario?.apellido || '',
        segundo_apellido: '',
        rut: usuario?.rut || '',
        telefono: usuario?.phoneNumber || '',
        celular: usuario?.phoneNumber || '',
        correo: isAnonimo ? '' : (usuario?.email || '')
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const formatRut = (rut) => {
        const cleanRut = rut.replace(/[^0-9kK]/g, '');
        if (cleanRut.length > 1) {
            return cleanRut.slice(0, -1) + '-' + cleanRut.slice(-1);
        }
        return cleanRut;
    };

    const handleRutChange = (e) => {
        const rawRut = e.target.value.replace(/[^0-9kK]/g, '');
        const formattedRut = formatRut(rawRut);
        setForm(prev => ({ ...prev, rut: formattedRut }));
    };

    const validarRUT = (rut) => {
        if (!rut) return false;
        const [cuerpo, dv] = rut.replace(/\./g, '').split('-');
        if (!cuerpo || !dv) return false;
        let suma = 0;
        let multiplo = 2;
        for (let i = cuerpo.length - 1; i >= 0; i--) {
            suma += Number(cuerpo.charAt(i)) * multiplo;
            multiplo = multiplo === 7 ? 2 : multiplo + 1;
        }
        const resultado = 11 - (suma % 11);
        const dvEsperado = resultado === 11 ? '0' : resultado === 10 ? 'K' : resultado.toString();
        return dv.toUpperCase() === dvEsperado;
    };

    const requiredFieldsFilled = () => {
        if (form.recaudador === "PatPass") {
            return form.nombre.trim() && form.apellido.trim() && validarRUT(form.rut) && form.celular.trim().length >= 8 && (isAnonimo ? Global.ValidateEmail(form.correo) : true);
        }
        if (form.recaudador === "Khipu") {
            return Global.ValidateEmail(form.correo);
        }
        return false;
    };

    const handleSuscripcionSubmit = () => {
        if (onLoading) {
            onLoading();
        } else {
            setCargando(true);
        }
    };

    const iframe = {};
    try { iframe.in = window.self !== window.top } catch { iframe.in = true; }

    return (
        <>
            {cargando && <div className="text-center p-5"><Spinner style={{ width: '3rem', height: '3rem' }} /><h4>Redirigiendo al portal de pago...</h4></div>}
            <Form style={{ display: cargando ? 'none' : 'block' }} onSubmit={handleSuscripcionSubmit} method="post" target={iframe.in ? "_blank" : null} action={form.recaudador ? `${Global.UrlApi}/Recaudacion/${empresa}/suscripcion/${Global.toTitleCase(form.recaudador)}/${isAnonimo ? 'GenerarAnonima' : 'Generar'}` : ""}>
                {montoMaximo &&
                    <Alert color="info" className={`text-left ${isAnonimo ? '' : 'mb-3'}`}>
                        <p>Al suscribir, autorizas a <strong>{empresaNombre}</strong> a realizar cobros automáticos por el monto de tu boleta mensual.</p>
                        <p className="mb-0">El monto máximo que se podrá cobrar en cada período es de <strong>${Global.FormatearNumero(montoMaximo)}</strong>.</p>
                    </Alert>
                }
                <div className="d-flex align-items-center mb-3">
                    {recaudadores.map(recaudador => (
                        <FormGroup key={recaudador} check inline>
                            <Label check>
                                <Input type="radio" name="recaudador" checked={form.recaudador === recaudador} onChange={() => setForm(prev => ({ ...prev, recaudador }))} />
                                {recaudador === "Khipu" ? <img src={Global.logosRecaudadores.khipu} width="80" alt="Khipu" /> :
                                    recaudador === "PatPass" ? <img src={Global.logosRecaudadores.patpass} width="80" alt="PatPass" /> :
                                        <span className="ml-2">{recaudador}</span>}
                            </Label>
                        </FormGroup>
                    ))}
                </div>

                {form.recaudador === "Khipu" && (
                    <FormGroup>
                        <Label for="correo">Correo electrónico *</Label>
                        <Input name="correo" value={form.correo} onChange={handleInputChange} type="email" required invalid={form.correo !== "" && !Global.ValidateEmail(form.correo)} />
                        <FormFeedback>Debe ser un correo válido.</FormFeedback>
                    </FormGroup>
                )}

                {form.recaudador === "PatPass" && (
                    <div className="border p-3 mb-3">
                        <Row>
                            <Col md={6}><FormGroup><Label>Nombre *</Label><Input name="nombre" value={form.nombre} onChange={handleInputChange} required /></FormGroup></Col>
                            <Col md={6}><FormGroup><Label>Apellido *</Label><Input name="apellido" value={form.apellido} onChange={handleInputChange} required /></FormGroup></Col>
                            <Col md={6}><FormGroup><Label>Segundo Apellido</Label><Input name="segundo_apellido" value={form.segundo_apellido} onChange={handleInputChange} /></FormGroup></Col>
                            <Col md={6}><FormGroup><Label>RUT *</Label><Input name="rut" value={form.rut} onChange={handleRutChange} placeholder="Ej: 12.345.678-9" required invalid={form.rut.length > 0 && !validarRUT(form.rut)} /><FormFeedback>RUT inválido</FormFeedback></FormGroup></Col>
                            {isAnonimo && <Col md={6}><FormGroup><Label>Correo electrónico *</Label><Input name="correo" value={form.correo} onChange={handleInputChange} type="email" required invalid={form.correo !== "" && !Global.ValidateEmail(form.correo)} /><FormFeedback>Debe ser un correo válido.</FormFeedback></FormGroup></Col>}
                            <Col md={6}><FormGroup><Label>Teléfono Fijo</Label><Input name="telefono" value={form.telefono} onChange={handleInputChange} type="tel" /></FormGroup></Col>
                            <Col md={6}><FormGroup><Label>Celular *</Label><Input name="celular" value={form.celular} onChange={handleInputChange} type="tel" minLength="8" required /></FormGroup></Col>
                        </Row>
                        <small className="text-muted">* Campos obligatorios</small>
                    </div>
                )}

                {/* Hidden Fields */}
                {!isAnonimo && API.Cookie && <input type="hidden" name="token" value={API.Cookie} />}
                <input type="hidden" name="id_servicio" value={servicio.id_servicio || servicio.idServicio} />
                {isAnonimo && <input type="hidden" name="servicioFalso" value={props.servicioFalso} />}
                <input type="hidden" name="empresa" value={empresa} />
                {isAnonimo && <input type="hidden" name="correo" value={form.correo} />}
            <input type="hidden" name="max_amount_form" value={montoMaximo} />

                {form.recaudador === "PatPass" && (
                    <>
                        <input type="hidden" name="nombre" value={form.nombre} />
                        <input type="hidden" name="apellido" value={form.apellido} />
                        <input type="hidden" name="segundo_apellido" value={form.segundo_apellido} />
                        <input type="hidden" name="rut" value={form.rut.replace(/[^0-9kK]/g, '')} />
                        <input type="hidden" name="telefono" value={form.telefono} />
                        <input type="hidden" name="celular" value={form.celular} />
                    </>
                )}

                <Button disabled={!form.recaudador || !requiredFieldsFilled()} type="submit" color="primary" size="lg" block className="mt-3">
                    Suscribir Pago Automático
                </Button>
                {props.onVolver &&
                    <Button color="secondary" size="lg" block className="mt-2" onClick={props.onVolver}>
                        Volver
                    </Button>
                }
            </Form>
        </>
    );
};

export default FormularioSuscripcion;